<template>
	<div id="header">
		<div class="cell">
			<div class="left">
				<div class="logo"></div>
			</div>
			<div class="right">
				<ul class="nav">
					<li :class="{active:'layout'== navName}">
				<router-link to="/">
					首页
				</router-link>
					</li>
					<li :class="{active:'map'== navName}">
				<router-link to="/map">
					地图
				</router-link>
					</li>
					<li :class="{active:'engine'== navName}" class="engine">
				<router-link to="/engine">
					平台
				</router-link>
					</li>
					<li :class="{active:'xqapp'== navName}">
				<router-link to="/xqapp">
					应用
				</router-link>
					</li>
					<li :class="{active:'facility'== navName}">
				<router-link to="/facilityCloud">
					装备
				</router-link>
					</li>
					<li :class="{active:'solution'== navName}">
				<router-link to="/solution">
					解决方案
				</router-link>
					</li>
					<li :class="{active:'about'== navName}">
				<router-link to="/about">
					关于我们
				</router-link>
					</li>
					<!-- <li :class="{active:'EN'== navName}">
									<router-link to="/EN">
					EN
									</router-link>
					</li> -->
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:'HomeHeader',
	data:function(){
		return {

		}
	},
	props:["navName"],
	methods:{

	},
  mounted: function(){
    $(window).scroll(function(event){
      if(window.scrollY > 300){
        $("#headerContent #header").css("background","#4b5768");
      }
    });
  }
}
</script>

<style scoped>
#header{
	position: fixed;
	top: 0px;
	left: 0px;
	right: 0px;
	padding-bottom: 70px;
	background: #4b5768;
	height: 0px;
	z-index: 10000;
}
#header .cell{
	position: relative;
}
#header .left{
	position: absolute;
	top:0px;
	left:0px;
	width: 400px;
	height: 100%;
}
#header .left .logo{
	width: 255px;
	height: 69px;
	background: url(../../assets/images/logo.png);
	margin-left: 120px;
}
#header .right{
	position: absolute;
	top: 0px;
	right: 0px;
	height: 100%;
}
#header .right ul{
	height: 100%;
	margin-right: 100px;
}
#header .right li{
	width: 65px;
	height: 66px;
	border-bottom: 4px solid #4b5768;
	line-height: 70px;
	display: inline-block;
	text-align: center;
	cursor: pointer;
	margin-right: 15px;
}
#header .right li:hover,
#header .right li.active{
	border-bottom: 4px solid #00bbf8;
	color: #ffffff;
}
#header .right li a{
	color: #747d90;
	padding: 10px 0px;
}
#header .right li:hover a,
#header .right li.active a{
	color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/header.vue